export default __webpack_public_path__ + "static/kb_2_13-027d009044db51208e4a6408e5f2a3cf.jpg";